import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Automatically scrolls to the top of the page when the route changes.
 * This provides a consistent user experience across all routes in the SPA
 * without needing individual scroll-to-top implementations in each component.
 * 
 * Usage: Place this component inside the Router but outside the Routes.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top whenever the pathname changes
    window.scrollTo(0, 0);
  }, [pathname]);

  // This component renders nothing
  return null;
}

export default ScrollToTop;